import { useState } from "react";
import { MapPin, Loader2, Check, X } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import DeliveryCountdown from "@/components/DeliveryCountdown";

export default function PincodeChecker({ compact = false }) {
  const { pincode, setPincode, pincodeInfo, setPincodeInfo } = useCart();
  const [value, setValue] = useState(pincode || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const check = async () => {
    setError("");
    if (!/^\d{6}$/.test(value)) { setError("Enter a 6-digit Indian pincode"); return; }
    setLoading(true);
    try {
      const { data } = await api.get(`/pincodes/check/${value}`);
      setPincodeInfo(data);
      setPincode(value);
      if (!data.deliverable) setError(data.message || "Not serviceable yet");
    } catch (e) {
      setError("Something went wrong. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className={`${compact ? "" : "bg-white/90 backdrop-blur-xl border border-white/60 shadow-xl"} rounded-2xl p-5`}>
      <div className="flex items-center gap-2 mb-2">
        <MapPin className="w-4 h-4 text-[#8C3A3A]" />
        <span className="overline">Delivery Check</span>
      </div>
      <div className="flex gap-2">
        <input
          data-testid="pincode-input"
          value={value}
          onChange={(e) => setValue(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="Enter your 6-digit pincode"
          className="input-eko flex-1"
          onKeyDown={(e) => e.key === "Enter" && check()}
        />
        <button data-testid="pincode-check-btn" onClick={check} disabled={loading} className="btn-primary">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Check"}
        </button>
      </div>
      {pincodeInfo?.deliverable && (
        <div className="mt-3 space-y-2" data-testid="pincode-result-success">
          <div className="flex items-center gap-2 text-sm text-[#4A5759]">
            <Check className="w-4 h-4" /> We deliver to {pincodeInfo.city}, {pincodeInfo.state} · ₹{pincodeInfo.delivery_fee} shipping
          </div>
          {pincodeInfo.express && (
            <div className="flex flex-wrap items-center gap-2" data-testid="pincode-express-badge">
              <div className="inline-flex items-center gap-1.5 bg-[#8C3A3A] text-white text-[11px] font-bold uppercase tracking-widest rounded-full px-3 py-1">
                <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
                Same-day & Midnight slots
              </div>
              <DeliveryCountdown compact />
            </div>
          )}
        </div>
      )}
      {error && (
        <div className="mt-3 flex items-center gap-2 text-sm text-[#8C3A3A]" data-testid="pincode-result-error">
          <X className="w-4 h-4" /> {error}
        </div>
      )}
    </div>
  );
}
